import { Checkbox, FormControlLabel } from "@mui/material";
import React from "react";
import { LOG_COLORS } from "../constants";

/**
 * Component for rendering log level filter checkboxes
 * @param {Object} props - Component props
 * @param {string} props.logLevel - Log level to display (DEBUG, INFO, etc)
 * @param {string[]} props.activeFilters - Array of currently active filters
 * @param {Function} props.onFilterChange - Function to call when filter changes
 * @returns {React.ReactElement} A checkbox with label styled according to log level
 */
const LogFilterCheckbox = ({ logLevel, activeFilters, onFilterChange }) => {
  const color = LOG_COLORS[logLevel];
  const isChecked = activeFilters.includes(logLevel);

  return (
    <FormControlLabel
      control={
        <Checkbox
          checked={isChecked}
          sx={{ color, "&.Mui-checked": { color } }}
          onChange={() => onFilterChange(logLevel)}
        />
      }
      label={logLevel}
      sx={{ color }}
    />
  );
};

export default LogFilterCheckbox;
